import { z } from 'zod'
import {
  featureFlagBaseSchema,
  singleScopeRefinement,
  singleScopeError,
} from './create-feature-flag.schema'

export const updateFeatureFlagSchema = featureFlagBaseSchema
  .partial()
  .refine(singleScopeRefinement, singleScopeError)
export type UpdateFeatureFlagDto = z.infer<typeof updateFeatureFlagSchema>
